import { PartnerRegistrationManagerDictionary } from 'types/i18n';
import {
  BYTES_IN_MB,
  PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE,
  PARTNER_PROFILE_AVATAR_INPUT_FILE_MAX_SIZE,
} from 'utils/constants';

export const partnerRegistrationManagerDictionaryRu: PartnerRegistrationManagerDictionary = {
  verificationForm: {
    titleText: 'Регистрация партнера',
    descriptionText: 'Укажите ваш секретный код:',
    invalidCodeDescriptionText: 'Некорректный код, попробуйте еще раз:',
  },
  passwordForm: {
    titleText: 'Придумайте пароль',
    descriptionText: 'Придумайте пароль для входа в аккаунт:',
    submitActionText: 'Продолжить',
  },
  profileForm: {
    titleText: 'Заполните анкету',
    submitActionText: 'Завершить регистрацию',
  },
  profieFieldset: {
    lastNameInputLabelText: 'Фамилия',
    firstNameInputLabelText: 'Имя',
    middleNameInputLabelText: 'Отчество',
    phoneInputLabelText: 'Ваш телефон',
    countryInputLabelText: 'Страна',
    cityInputLabelText: 'Город',
    avatarInputLabelText:
      'Выберите презентабельное фото, анкету увидят клиенты:',
    avatarInputPlaceholderText: 'Изменить фото',
    avatarInputNoValuePlaceholderText: 'Выбрать фото',
    detailsInputLabelText: 'Опишите ваш профессиональный опыт',
    avatarRequirementsHintText: 'Мин. размер: 500х500px\nФормат: JPEG, PNG',
    avatarInputFileSizeViolationText: `Выберите файл\nразмером до ${Math.round(
      PARTNER_PROFILE_AVATAR_INPUT_FILE_MAX_SIZE / BYTES_IN_MB
    )}Mb`,
    avatarCroppedFileSizeViolationText: `Итоговый файл превышает допустимый размер ${Math.round(
      PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE / BYTES_IN_MB
    )}Mb`,
    avatarFileTypeViolationText: 'Допустимые форматы\nJPEG, PNG',
    avatarImageSizeViolationText: 'Минимальный размер\n500х500px',
  },
};
